@if (legalEntity) {
  <div class="lg:mt-16 max-w-[400px] mx-auto p-8 bg-card rounded-lg">
    <div>
      <div
        class="text-l font-semibold"
        [ngClass]="{
        'text-toyotaRed': legalEntity.vehicleBrand.isToyota,
        'text-lexusBlue': !legalEntity.vehicleBrand.isToyota
        }"
      >
        Ihr Zugangs-Link ist abgelaufen.
      </div>
      <div class="text-lightText mt-4">
        Bitte melden Sie sich erneut an, indem sie einen
        <a href="/lookup">neuen Zugangs-Link via E-Mail anfordern</a>
      </div>
    </div>

    <div class="mt-4">
      <a
        class="flex items-center bg-white font-semibold border-2 hover:bg-[#FEFEFE]
                hover:scale-105 duration-150 rounded-lg px-2 py-1 text-xs lg:text-lg
                shadow-lg"
        href="/lookup"
        [ngClass]="{
        'text-toyotaRed': legalEntity.vehicleBrand.isToyota,
        'text-lexusBlue': legalEntity.vehicleBrand.isLexus,
        }"
      >
        Link anfordern
      </a>
    </div>
  </div>
}
